import { useState, useEffect } from 'react';

const JITOSOL_MINT = 'J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn';

export const useJitoSOLPrice = () => {
    const [price, setPrice] = useState<number | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const fetchPrice = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await fetch(
                `https://lite-api.jup.ag/price/v3?ids=${JITOSOL_MINT}`
            );
            const data = await response.json();
            const jupPrice = data?.[JITOSOL_MINT]?.usdPrice;
            if (typeof jupPrice === 'number') {
                setPrice(jupPrice);
            } else {
                throw new Error('Jupiter price data not found');
            }
        } catch (err) {
            console.error('Error fetching JitoSOL price from Jupiter:', err);
            setError('Error fetching JitoSOL Price');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchPrice();
    }, []);

    return { price, isLoading, error };
};
